import React from 'react'
import styled, { css } from 'styled-components'
import { TileFormParagraph } from '@dataplace.ai/ui-components/atoms'

const TilesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
`

const TileButton = styled.button<{ $active: boolean }>(({
  theme: {
    palette, typography, corners,
  },
  $active,
}) => css`
    padding: 1.25rem 1rem;
    border-radius: ${corners.default.borderRadius};
    background: ${$active ? palette.softLavender : palette.light.white};
    border: 2px solid ${$active ? palette.electricBlue : palette.grey};
    color: ${palette.dark.normal};
    cursor: pointer;
    font-size: ${typography.small.pt_14_medium.fontSize};
    font-weight: ${typography.small.pt_14_medium.fontWeight};
    transition: 0.15s ease;

    &:hover {
      opacity: 0.85;
    }

    &:active {
      transform: scale(0.98);
    }
`)

interface MultiTilesFieldProps {
  label: string
  values: string[]
  options: Array<{ value: string | number | boolean; label?: string }>
  onChange: (newValues: string[]) => void
}

export const MultiTilesField: React.FC<MultiTilesFieldProps> = ({
  label,
  values,
  options,
  onChange,
}) => (
  <>
    <TileFormParagraph>{label}</TileFormParagraph>

    <TilesWrapper>
      {options.map(option => {
        const value = String(option.value)
        const isActive = values.includes(value)

        return (
          <TileButton
            key={value}
            $active={isActive}
            onClick={() => {
              const newValues = isActive
                ? values.filter(v => v !== value)
                : [...values, value]
              onChange(newValues)
            }}
            type='button'
          >
            {option.label}
          </TileButton>
        )
      })}
    </TilesWrapper>
  </>
)
